class ProductForm extends HTMLElement {
  constructor() {
    super();
  }
}

const productSelect = document.getElementById('product-select');
const productVariants = productSelect.querySelectorAll('option');
const inStockContainer = document.querySelector('.in-stock-container');
const preOrderContainer = document.querySelector('.oo-stock-container');
const noStockMessage = document.querySelector('.oos-message');
const colorSwatches = document.querySelectorAll('.product-option-colour.product-owl-carousel-dots li');
const addToCartButton = document.getElementById('AddToCart');
const backOrderButton = document.querySelector('.backorder-button');

const toggleStockNoStockContainers = (selectedVariant) => {
  productVariants.forEach((variant) => {
    if(variant.value === selectedVariant) {
      document.getElementById('quantity').value = 1;

      if (variant.dataset.stock > 0) {
        preOrderContainer.style.display = 'none'
        noStockMessage.style.display = 'none'
        inStockContainer.style.display = 'block'
        addToCartButton.classList.remove('disabled')
        addToCartButton.disabled = false
        addToCartButton.querySelector('#AddedToCartText').style.display = 'none'
        addToCartButton.querySelector('#AddToCartText').style.display = 'block'
        addToCartButton.querySelector('#AddToCartText').textContent = 'Add to cart'
      } else if (variant.dataset.stock <= 0 && variant.dataset.inventory_policy === 'continue') {
        inStockContainer.style.display = 'none'
        noStockMessage.style.display = 'none'
        preOrderContainer.style.display = 'block'
        backOrderButton.classList.remove('disabled')
        backOrderButton.disabled = false
        backOrderButton.querySelector('#BackOrder').textContent = 'Backorder'
      } else {
        inStockContainer.style.display = 'none'
        preOrderContainer.style.display = 'none'
        noStockMessage.style.display = 'block'
      }
    }
  });
}

toggleStockNoStockContainers(productSelect.value);

colorSwatches.forEach(color => {
  color.addEventListener('click', function() {
    console.log('colorSwatches', color.dataset.value)
    toggleStockNoStockContainers(color.dataset.value)
  })
})
